// store/modules/file/actions.js
import FileApi from "../../../api/modules/FileApi";
import util from '../../../util'

const loadFilesWithFilters = async ({commit}, payload) => {
  try {
    const {context, ...data} = payload;
    return await FileApi.searchFiles(context, data);
  } catch (error) {
    console.error("Error al buscar archivos:", error);
    throw error;
  }
};

const filesByBoxWithFilters = async ({commit}, payload) => {
  try {
    const {context, ...data} = payload;
    return await FileApi.filesByBox(context, data);
  } catch (error) {
    console.error("Error al buscar archivos:", error);
    throw error;
  }
};

const createFile = async ({commit}, payload) => {
  try {
    const {context, file} = payload;
    return await FileApi.saveFile(context, {file});
  } catch (e) {
    console.error("Error al crear caja:", e);
    throw e;
  }
};

export const editFile = async ({commit}, payload) => {
  try {
    const {context, idFile, request} = payload;
    return await FileApi.editFile(context, idFile, request);
  } catch (e) {
    console.error("Error al editar archivo:", e);
    throw e;
  }
};

const exportFilesReportAsync = async ({commit}, payload) => {
  try {
    const {context, filters, email} = payload;
    return await FileApi.exportFilesReportAsync(context, {filters, email});
  } catch (error) {
    console.error("Error al exportar reporte:", error);
    throw error;
  }
};

const exportFilesReportAsyncFromSession = (_, payload) => {
  return FileApi.exportFilesReportAsyncFromSession(payload.context, payload.filters);
};

const searchFiles = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`api/files/${payload.idClient}?${payload.params}`, {headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al buscar los archivos.')
        reject(error.response)
      } else reject(error)

    });

  })

}

const searchOtros = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`api/otros/findall/${payload.type}/${payload.idClient}?${payload.params}`, {headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al buscar los archivos.')
        reject(error.response)
      } else reject(error)

    });

  })

}

const findFileById = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`api/files/${payload.idClient}/${payload.idFile}`, {headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar el archivo.')
        reject(error.response)
      } else reject(error)
    });

  })

}

const findOtrosById = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`api/files/${payload.idClient}/${payload.idFile}`, {headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar el archivo.')
        reject(error.response)
      } else reject(error)

    });

  })

}

const loadTrackingFile = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`api/files/tracking/${payload.idFile}`, {headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar el tracking.')
        reject(error.response)
      } else reject(error)

    });

  })

}

const loadLatestFiles = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`api/files/${payload.idClient}/latest/${payload.codeRange}`, {headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar el tracking.')
        reject(error.response)
      } else reject(error)

    });

  })

}

const loadLatestOtros = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`api/otros/${payload.type}/${payload.idClient}/latest/${payload.codeRange}`, {headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar el tracking.')
        reject(error.response)
      } else reject(error)

    });

  })

}

const updateFile = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put(`api/files?${payload.params}`, payload.file, {headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el archivo.')
        reject(error.response)
      } else reject(error)

    });

  })

}

const saveFile = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post('api/files', payload.file, {headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar el archivo.')
        reject(error.response)
      } else reject(error)

    });

  })

}

const saveOtros = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()


    payload.context.axios.post('api/otros', payload.file, {headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar el archivo.')
        reject(error.response)
      } else reject(error)

    });

  })

}

const attachFiles = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeaderMultipart()

    var data = new FormData();

    for (var i = 0; i < payload.files.length; i++) {
      let attached = payload.files[i]
      data.append('attachments', attached);
    }

    payload.context.axios.post(`storage/upload/multi/${payload.idClient}/${payload.idFile}`, data, {headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });

  })

}

const saveAmountImages = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.post(`storage/attachments/idFile/${payload.idFile}`, payload.files, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      }
      reject(error.response)
    });
  })
}

const loadAttachments = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`storage/attachments/${payload.idFile}`, {headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });

  })

}

const downloadAttached = ({commit}, payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`/storage/download/${payload.bucket}/${payload.name}/${payload.ext}`, {
      headers,
      responseType: 'blob'
    }).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', payload.orgininalFileName);
      document.body.appendChild(link);
      link.click();

      resolve(response.data)

    }).catch(error => {
      const reader = new FileReader()

      // This fires after the blob has been read/loaded.
      reader.addEventListener('loadend', (e) => {
        const text = e.srcElement.result;
        const obj = JSON.parse(text)
        util.showDialogError(payload.context, obj.message)
      });
      reader.readAsText(error.response.data);

      reject(error)
    });

  })

};

const loadDigitalizations = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`api/digitalizations`, {headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });

  })

}

const delivereDigitalization = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch(`api/digitalization/${payload.id}/delivered`, {}, {headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });

  })

}

const completeDigitalization = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch(`api/digitalization/${payload.id}/complete`, {}, {headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });

  })

}

const noCompleteDigitalization = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.patch(`api/digitalization/${payload.id}/${payload.comment}/nocomplete`, {}, {headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });

  })

}

const updateStatus = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch(`api/files/updateStatus`, payload.changeStatusFile, {headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el archivo.')
        reject(error.response)
      } else reject(error)

    });

  })

}

const loadInquiries = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`api/inquiries`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });

  })

}

const approveInquiries = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch(`api/inquiries/${payload.id}/client/${payload.idClient}/approve`, {}, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)
    });
  })

}

const disapproveInquiries = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch(`api/inquiries/${payload.id}/${payload.comment}/client/${payload.idClient}/disapprove`, {}, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)
    });
  })

}

const finalizeInquiries = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.put(`api/inquiries/finalize`, payload.inquiries, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)
    });
  })

}

const saveFiles = async ({commit}, payload) => {
  try {
    const {context, files, type} = payload;
    const param = `type=${type}`;

    const response = await FileApi.saveFilesFromExcel(
      context,
      {dataSave: files},
      param
    );

    return response;
  } catch (e) {
    console.error("Error al guardar archivos (FILES):", e);
    throw e;
  }
};

const bulkUploadFiles = async ({commit}, {context, payload}) => {
  try {
    return await FileApi.bulkUploadFiles(context, payload);
  } catch (e) {
    console.error("Error en carga masiva:", e);
    throw e;
  }
};

export default {
  loadFilesWithFilters,
  filesByBoxWithFilters,
  createFile,
  editFile,
  exportFilesReportAsync,
  exportFilesReportAsyncFromSession,
  searchFiles,
  searchOtros,
  findFileById,
  updateFile,
  loadTrackingFile,
  loadLatestFiles,
  loadLatestOtros,
  saveFile,
  saveOtros,
  attachFiles,
  loadAttachments,
  downloadAttached,
  loadDigitalizations,
  completeDigitalization,
  noCompleteDigitalization,
  updateStatus,
  delivereDigitalization,
  loadInquiries,
  approveInquiries,
  disapproveInquiries,
  finalizeInquiries,
  saveAmountImages,
  saveFiles,
  bulkUploadFiles
};



// WEBPACK FOOTER //
// ./src/store/modules/file/actions.js